import styled from "styled-components";
import { CustomParagraph, CustomTitle } from "../custom/CustomText";
import { useState, useEffect } from "react";
import { COLORS_LIGHT, FONT, TEXT } from "../custom/Values";
import { Section, Col } from "../custom/Elements";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Shapes } from "../components/Shapes";
import { Socials } from "../components/Socials";
import { BasicInfo } from "../BasicInfo";
import { Publications } from "../components/Publications";
import { Experience } from "../components/Experience";

export const HomePage = () => {
  const [newsContent, setNewsContent] = useState([]);

  if (!BasicInfo) {
    return;
  } else {
    return (
      <>
          <Socials />
        <HomeSection>

          <RightSection>
            <HomeImageContainer>
              <ContourContainer>
                <img
                  marginTop="-10px"
                  class="contour"
                  src="https://raw.githubusercontent.com/biniyam-mt/website/main/contour2.png"
                  height={"115%"}
                />
              </ContourContainer>
              <ShapesContainer>
                <Shapes />
              </ShapesContainer>

              <HeadshotContainer>
                <Headshot
                  src={BasicInfo.photoUrl}
                  // src={"./new_bage.png"}
                />
              </HeadshotContainer>
            </HomeImageContainer>
          </RightSection>
          <LeftSection>
            <MyName>{BasicInfo.fullName}</MyName>
            <MyTitle>
              <strong>{BasicInfo.title}</strong> {BasicInfo.department}
            </MyTitle>
            <MyCampus>{BasicInfo.university} </MyCampus>
            {/* <MyCampus>
              Advised by <strong>Professor Todd Austin</strong>
            </MyCampus>

            <MyEmail>
              <InfoText>{BasicInfo.email}</InfoText>
            </MyEmail> */}
          </LeftSection>
        </HomeSection>
        <AboutSection align={true}>
          <BioContainer>
            <CustomParagraph
              display="full"
              limit={800}
              body={BasicInfo.personalBiography}
            />
          </BioContainer>
        </AboutSection>
        <S3>
          <CustomTitle title={"PUBLICATIONS"} />
          <S3R1>
            <Publications publications={BasicInfo.research.publications} />
          </S3R1>
        </S3>
        <S3>
          <CustomTitle title={"EXPERIENCE"} />
          <S3R1>
            <Experience experience={BasicInfo.experience} />
          </S3R1>
        </S3>
        {/* <S3>
          <CustomTitle title={"TESTIMONIALS"} />
          <S3R1></S3R1>
        </S3> */}
      </>
    );
  }
};

export const Education = ({ edu }) => {
  return (
    <EduContainer>
      <EduLogo>
        <ImageContainer>
          <img src={edu.logoUrl} width={"100%"} />
        </ImageContainer>
      </EduLogo>
      <EduText>
        <EduCampus>{edu.institute}</EduCampus>
        <EduTitle>{edu.title}</EduTitle>
        <EduDate>{edu.duration}</EduDate>
        <EduGrade>{edu.grade}</EduGrade>
      </EduText>
    </EduContainer>
  );
};

export const HomeSection = styled.div`
  // max-height:950px;
  // box-sizing: border-box;
  //   border: 1px solid green;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${(props) => (props.align ? "start" : "center")};
  // padding-top: 45px;
  // width: 100%;
  margin-bottom: 5px;
  background-color: ${(props) => (props.bg2 ? COLORS_LIGHT.SECONDARY_BG : "")};

  @media (max-width: 1024px) {
    // background-color:red;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-around;
    align-items: center;
  }
  @media (min-width: 1024px) {
    height: calc(100vh - 180px);
  }
`;

const LeftSection = styled.div`
  //   border: 1px solid red;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-family: Montserrat;
  margin: 0px 25px;
  @media (max-width: 1024px) {
    // background-color:green;
    align-items: center;
    margin-top: 25px;
  }
`;

const RightSection = styled.div`
  //   border: 1px solid blue;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1024px) {
    // background-color:blue;
  }
`;
const ImageContainer = styled.div({
  position: "relative",
});

const HomeImageContainer = styled.div`
  position: relative;
  // border: 1px solid purple;
  width: 600px;
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1024px) {
    width: 350px;
    height: 350px;
  }
`;

const ContourContainer = styled.div`
  // border: 1px solid red;
  width: 90%;
  height: 90%;
  border-radius: 50%;
  background-color: #e1d19b;
  display: block;
  overflow: hidden;

  @media (max-width: 1024px) {
    //  width: 300px;
    // height: 300px;
  }
`;

const HeadshotContainer = styled.div`
  // border: 1px solid red;
  width: 100%;
  height: 100%;
  // border-radius: 50%;
  position: absolute;
  top: 0;
  @media (max-width: 1024px) {
    // width: 300px;
    // height: 300px;
  }
`;
const Headshot = styled.img`
  // border: 1px solid blue;
  width: 100%;
  height: 100%;
  @media (max-width: 1024px) {
  }
`;

const ShapesContainer = styled.div`
  // border: 1px solid red;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const AboutSection = styled.div`
    // border: 1px solid green;
  display: flex;
  justify-content: space-around;
  align-items: ${(props) => (props.align ? "start" : "center")};
  width: 100%;
  margin-bottom: 5px;
  @media (max-width: 1024px) {
    // background-color:red;
    flex-direction: column;
    // justify-content: space-around;
    align-items: center;
  }
`;
const BioContainer = styled.div`
    // border: 1px solid green;
  text-align: justify;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // background-color: ${COLORS_LIGHT.SECONDARY_BG};
  align-items: center;
  font-family: Montserrat;
  padding: 15px;
  margin: 0px 0px;
  @media (max-width: 1024px) {
    // background-color:red;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
  @media (min-width: 1024px) {
    // margin: 0px 45px;
    // width: 50%;
  }
`;

const EducationContainer = styled.div`
  // border: 1px solid green;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  font-family: Montserrat;
  @media (max-width: 1024px) {
    // background-color:red;
    justify-content: center;
    align-items: center;
    padding: 15px;
    margin-bottom: 10px;
  }
  @media (min-width: 1024px) {
    margin: 0px 45px;
    width: 100%;
  }
`;

const EduContainer = styled.div({
  // border: "1px solid green",
  display: "flex",
  justifyContent: "start",
  alignItems: "start",
  marginBottom: "15px",
});
const EduLogo = styled.div({
  // border: "1px solid green",
  width: 40,
  height: 40,
  margin: "0px 15px 10px 10px",
});

const EduText = styled.div({
  // border: "1px solid green",
  fontFamily: TEXT.FONT,
});

const EduCampus = styled.div({
  // border: "1px solid red",
  color: COLORS_LIGHT.BLACK,
  fontSize: TEXT.SIZE_3,
  fontWeight: "bold",
  marginBottom: 2,
});

const EduTitle = styled.div({
  // border: "1px solid green",
  color: COLORS_LIGHT.BLACK,
  marginBottom: 2,
  fontSize: TEXT.SIZE_2,
});
const EduDate = styled.div({
  // border: "1px solid red",
  color: COLORS_LIGHT.MEDIUM_GRAY,
  fontSize: TEXT.SIZE_1,
  marginBottom: 5,
});

const EduGrade = styled.div({
  // border: "1px solid green",
  color: COLORS_LIGHT.BLACK,
  fontSize: TEXT.SIZE_2,
  fontWeight: "bold",
  marginBottom: 2,
});

const MyName = styled.div`
  font-size: ${TEXT.SIZE_7};
  margin-bottom: 15px;

  @media (max-width: 1024px) {
    font-size: ${TEXT.SIZE_5};
  }
`;

const MyTitle = styled.div`
  color: ${COLORS_LIGHT.BLACK};
  margin-bottom: 5px;
  @media (max-width: 1024px) {
    font-size: ${TEXT.SIZE_2};
    text-align: center;
  }
`;
const MyCampus = styled.div`
  color: ${COLORS_LIGHT.MEDIUM_GRAY};
  margin-bottom: 15px;
  @media (max-width: 1024px) {
    font-size: ${TEXT.SIZE_2};
    text-align: center;
  }
`;

const MyLocation = styled.div({
  // border: "1px solid red",
  width: "100%",
  color: COLORS_LIGHT.DARK_GRAY,
  marginBottom: "10px",
  display: "flex",
  justifyContent: "start",
  fontSize: TEXT.SIZE_1,
  // alignItems: "center",
});

const MyEmail = styled.div({
  color: COLORS_LIGHT.MEDIUM_GRAY,
  marginBottom: "5px",
  display: "flex",
  justifyContent: "start",
  fontSize: TEXT.SIZE_1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const InfoIcons = styled.div({
  // border: "1px solid red",
  width: "25px",
});
const CopyIcon = styled.div({
  // border: "1px solid " + COLORS_LIGHT.LIGHT_GRAY,
  width: "20px",
  height: "20px",
  marginLeft: "20px",
  borderRadius: "15%",
  padding: "3px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: "0px 1px 3px " + COLORS_LIGHT.LIGHT_GRAY,
});
const InfoText = styled.span({
  // border: "1px solid red",
  // width: "9px",
});

const S1C2 = styled.div({
  // border: "1px solid red",
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
});

const ScrollDown = styled.div({
  // border: "1px solid red",
  width: "100%",
  // alignSelf: "start",
  color: COLORS_LIGHT.ACCENT,
  fontFamily: TEXT.FONT,
  fontSize: TEXT.SIZE_2,
  marginBottom: "20px",
  display: "flex",
  alignItems: "end",
  justifyContent: "space-between",
});

const S3 = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "start",
  alignItems: "center",
  paddingTop: "35px",
  width: "100%",
});

const S4 = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "start",
  alignItems: "center",
  paddingTop: "35px",
});

const S2R1 = styled.div({
  // border: "1px solid red",
  display: "flex",
  flexDirection: "column",
  justifyContent: "start",
  width: "95%",
  padding: "0px 10px",
});

const S3R1 = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "start",
  width: "95%",
  padding: "0px 10px",
  marginBottom: "30px",
  // border: "1px solid red",
});
